import React, { useState } from 'react'
import styled from 'styled-components';
import CircledDropUp from '../components/Icon/CiircledDropUp';
import userPF from "../assets/images/user.png"
import PPMori from "../assets/fonts/PPMori-Regular.otf";
import CircledDropDown from '../components/Icon/CircledDropDown';
import { useData } from '../context/DataProvider';
import RedirectModal from '../components/RedirectModal';
const Account = () => {
    const [userInfoTab,setUserInfoTab] = useState(true);
    const {data,sessionExpired} = useData();
    const [subscriptionTab,setSubscriptionTab] = useState(true);
    
  return (
    <Container>
        <RedirectModal isOpen={sessionExpired}/>
        <Main>
            <M1>
            <M11>
                    <M11Text>
                    User Information
                    </M11Text>
                  <ToggleButton onClick={()=>setUserInfoTab(!userInfoTab)}>
                    {userInfoTab ? <CircledDropUp/> : <CircledDropDown/>}
                    </ToggleButton>
                </M11>
                {userInfoTab && <>
                    <M12>
                    <PF src={userPF}>
                        
                    </PF>
                    {/* <M122>
                        <M1221>
                            <M1221Txt>
                                UPLOAD
                            </M1221Txt>
                        <Write/>

                        </M1221>
                        <M1221 style={{background:'#2023270F'}}>
                        <M1221Txt>
                                DELETE
                            </M1221Txt>
                            <Delete/>

                       
                        </M1221>
                       

                    </M122> */}
                    

                </M12>
                <N>
                            <N1>
                                <N11>
                                    <N11Txt>
                                    First name
                                    </N11Txt>
                                    <OText>{data.userData.firstName}</OText>
                                </N11>
                                <N11>
                                    <N11Txt>
                                    Last name
                                    </N11Txt>
                                    <OText>{data.userData.lastName}</OText>
                                </N11>
                            </N1>
                            <N11>
                                    <N11Txt>
                                        Email
                                    </N11Txt>
                                    <OText>{data.userData.email}</OText>
                                </N11>
                        </N>
                        {/* <O>
                            <Delete/>
                            <OText>DELETE PROFILE</OText>
                        </O> */}
                        </>}

            </M1>
            {/* <M1>
            <M11>
                    <M11Text>
                    Change Password
                    </M11Text>
                    <ToggleButton onClick={()=>setChangePasswordTab(!changePasswordTab)}>
                    {changePasswordTab ? <CircledDropUp/> : <CircledDropDown/>}
                    </ToggleButton>
                </M11>
               {
               changePasswordTab &&
               <N><N1 style={{flexDirection:'column'}}>
                                    <N11Txt>
                                        CURRENT PASSWORD
                                    </N11Txt>
                                    <N11Input type='password' />
                                </N1>
                                <N1 style={{flexDirection:'column'}}>
                                    <N11Txt>
                                        NEW PASSWORD
                                    </N11Txt>
                                    <N11Input  type='password'/>
                                </N1>
                        </N>}
                      

            </M1> */}
            <M1>
            <M11>
                    <M11Text>
                    Subscription & Billing
                    </M11Text>
                    <ToggleButton onClick={()=>setSubscriptionTab(!subscriptionTab)}>
                    {subscriptionTab ? <CircledDropUp/> : <CircledDropDown/>}
                    </ToggleButton>
                </M11>
               {subscriptionTab && 
               <div style={{display:'flex',justifyContent:'center'}}>
                <AddButton target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_SUBSCRIPTION_URL}>
                {/* <CircledCheck/> */}
                <M11Text>
                Manage Subscription
                </M11Text>

            </AddButton> 
            </div>
            //    <SS>
            //     <N1 style={{flexDirection:'column'}}>
            //     <S>
            //         <N11>
            //             <S1Txt>
            //                 Monthly
            //             </S1Txt>
            //             <S1Txt2>
            //             Next payment on January 1st, 2025 for <span style={{fontWeight:700}}>$16 monthly</span>
            //             </S1Txt2>
            //         </N11>
            //         <S2>
            //             <S2Txt>CANCEL SUBSCRIPTION</S2Txt>
            //             <NextArrow/>
            //         </S2>

            //     </S>
            //     <S3>
            //         <S1Txt>
            //             Annual
            //         </S1Txt>
            //         <S2>
            //             <S2Txt>SWITCH TO ANNUAL</S2Txt>
            //             <NextArrow/>
            //         </S2>
            //     </S3>
            //     </N1>
                
            //     <N11>
            //         <N11Txt>
            //             BILLING HISTORY
            //         </N11Txt>
            //         <S31>
            //             <M11Text>
            //             December 1, 2024
            //             </M11Text>
            //             <M11Text style={{color:'#20232799'}}>
            //            Monthly
            //             </M11Text>
            //             <S2>
            //                 <S2Txt>PDF</S2Txt>
            //                 <Downlaod/>
            //             </S2>
            //         </S31>
            //         <S31>
            //             <M11Text>
            //             December 1, 2024
            //             </M11Text>
            //             <M11Text style={{color:'#20232799'}}>
            //            Monthly
            //             </M11Text>
            //             <S2>
            //                 <S2Txt>PDF</S2Txt>
            //                 <Downlaod/>
            //             </S2>
            //         </S31>
            //         <S31>
            //             <M11Text>
            //             December 1, 2024
            //             </M11Text>
            //             <M11Text style={{color:'#20232799'}}>
            //            Monthly
            //             </M11Text>
            //             <S2>
            //                 <S2Txt>PDF</S2Txt>
            //                 <Downlaod/>
            //             </S2>
            //         </S31>

            //     </N11>
            //     <N11>
            //     <N11Txt>
            //             BILLING HISTORY
            //         </N11Txt>
            //         <S31>
            //             <M11Text>
            //             Visa ending in 1376 expiring 04/2029
            //             </M11Text>
            //             <S2Txt>
            //            REMOVE
            //             </S2Txt>
                        
            //         </S31>

            //     </N11>
            //     <S32>
            //         <CircledPlus/>
            //         <OText>
            //             ADD NEW CARD
            //         </OText>

            //     </S32>
                
            //     </SS>
                }
                      

            </M1>

            {/* <AddButton>
                <CircledCheck/>
                <M11Text>
                    Save changes
                </M11Text>

            </AddButton> */}

        </Main>
      
    </Container>
  )
}

export default Account;

const Container = styled.div`

padding: 30px;
gap: 30px;
border: 0px 1px 0px 0px;
opacity: 0px;

`
const ToggleButton = styled.button`
background:#F9F9F9;
cursor:pointer;
display:flex;
align-items:center;
border:none`

const Main = styled.div`

padding: 24px;
gap: 24px;
border-radius: 24px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;

display:flex;
align-items:center;
flex-direction:column;


opacity: 0px;
`
const M1 = styled.div`
width: 450px;

padding: 30px;
display:flex;
flex-direction:column;
gap: 30px;
border-radius: 18px;

background:#F9F9F9;
@media (max-width: 768px) {
        width:90%;
    }
`

const AddButton = styled.a`

height: 40px;
width:40%;
cursor:pointer;
justify-content:center;
padding: 0px 20px 0px 16px;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
align-items:center;
display:flex;
text-decoration:none;
@media (max-width: 768px) {
        width:90%;
    }

`

const M11 = styled.div`




display:flex;
justify-content: space-between;
align-items:center;
`

const M11Text = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
color:#202327;
`
const M12 = styled.div`

height: 84px;
gap: 0px;
display:flex;
justify-content: space-between;

opacity: 0px;
`

const PF = styled.img`
width: 84px;
height: 84px;
gap: 0px;
border-radius: 18px;
opacity: 0px;
`
const M122 = styled.div`
width:204px;
height:29px;
display:flex;
gap: 10px;
opacity: 0px;
`

const M1221 = styled.div`
width:98px;
height:29px;
padding: 8px 12px 6px 14px;
display:flex;
gap: 8px;
border-radius: 64px;
align-items:center;
opacity: 0px;
background:#FFFFFF;
`

const M1221Txt = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 12px;
font-weight: 800;
line-height: 14.4px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;


`

const N = styled.div`

height: 185px;
display:flex;
flex-direction:column;
gap: 16px;
opacity: 0px;
`
const N1 = styled.div`
display:flex;
gap: 6px;
`
const N11 = styled.div`
display:flex;
width:100%;
gap: 8px;

flex-direction:column;
`

const N11Txt = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 12px;
font-weight: 700;
line-height: 14.4px;
letter-spacing: -0.01em;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#20232799; 
`

const N11Input = styled.input`
outline:none;
border:none;
padding: 12px;
display:flex;
gap: 8px;
border-radius: 12px;
background:#FFFFFF;
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 14px;
font-weight: 600;
line-height: 16.8px;
letter-spacing: -0.01em;
color:#202327;
`

const O = styled.div`
width: 390px;
height: 25px;
padding: 7px;
display:flex;
gap: 8px;
align-items:center;
`

const OText = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 12px;
font-weight: 700;
line-height: 14.4px;
letter-spacing: -0.01em;
// text-align: right;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;
`
const SS = styled.div`
displat:flex;
flex-direction:column;
gap:20px;
`
const S = styled.div`

padding: 20px;
displat:flex;
flex-direction:column;

background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);


gap: 24px;
border-radius: 12px;

`

const S1Txt   = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 20px;
font-weight: 600;
line-height: 24px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;
`
const S1Txt2 = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 14px;
font-weight: 500;
line-height: 16.69px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;

`
const S2 = styled.div`
display:flex;
gap:8px;
align-items:center;
`
const S2Txt = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   
  }

font-size: 12px;
font-weight: 800;
line-height: 14.4px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

`
const S3 = styled.div`
padding: 20px;
height:65px;
display:flex;
border-radius: 12px;
background:#FFFFFF;
align-items:center;
justify-content: space-between;

`

const S31 = styled.div`
padding: 16px 20px 16px 20px;
border-radius: 12px ;
background: #FFFFFF;
align-items:center;
display:flex;
justify-content:space-between;

`

const S32 =styled.div`
padding: 7px;
display:flex;
align-items:center;
gap: 8px;
`